// assets/blog-progress.js
// Simple reading progress bar for article pages

(function () {
  var progress = document.getElementById('reading-progress');
  if (!progress) return;

  function updateProgress() {
    // Only operate on article pages with our wrapper
    if (!document.querySelector('.template-article')) {
      progress.style.width = '0%';
      return;
    }

    var article = document.querySelector('.article-body');
    if (!article) {
      progress.style.width = '0%';
      return;
    }

    var articleTop = article.getBoundingClientRect().top + window.scrollY;
    var articleHeight = article.offsetHeight;
    var windowH = window.innerHeight;
    var maxScroll = articleTop + articleHeight - windowH;
    var scrollY = window.scrollY || window.pageYOffset;

    var pct = 0;
    if (maxScroll > articleTop) {
      pct = ((scrollY - articleTop) / (maxScroll - articleTop)) * 100;
      pct = Math.min(100, Math.max(0, pct));
    } else {
      pct = scrollY > articleTop ? 100 : 0;
    }

    progress.style.width = pct + '%';
  }

  // Update on common events
  ['scroll', 'resize', 'DOMContentLoaded', 'load'].forEach(function (ev) {
    window.addEventListener(ev, updateProgress, { passive: true });
  });

  // initial call
  updateProgress();
})();

// ------------------
// Auto-generate TOC
// ------------------
(function () {
  var toc = document.getElementById('article-toc');
  var articleBody = document.querySelector('.article-body');
  if (!toc || !articleBody) return;

  var headings = articleBody.querySelectorAll('h2, h3');
  if (headings.length === 0) return;

  var ul = toc.querySelector('ul');
  headings.forEach(function (h, index) {
    // create ID if missing
    if (!h.id) {
      h.id = 'heading-' + index;
    }
    var li = document.createElement('li');
    li.style.marginLeft = h.tagName === 'H3' ? '12px' : '0'; // indent H3s
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    ul.appendChild(li);
  });

  toc.classList.remove('u-hidden');
})();
